var exports = {
  "V7": "Stackable__4c1raB",
  "q7": "Item__crGDsr",
  "DX": "Slot__sX2hJB",
  "BJ": "Stack__Ba_Thn",
  "ho": "StackInner__7tYCN-",
  "Lx": "isClosed__giFQsR",
  "_C": "isHovered__2tx5SM",
};

module.exports = exports;
